import { prefixObjectValues } from '../utils';

const footer = {
  linkedin: 'linkedin-link',
};

export default prefixObjectValues(footer, 'site-footer');
